import {axiosInstance} from "@/plugins/axios";
import {Subassembly} from "@/modules/subassembly/types";
export interface SubassemblyFilter {
  month: string,
  search: string,
  offset: number,
  limit: number
}

export interface SubassemblyPayload {
  month: string,
  id: string,
}

export async function getSubassemblies(payload: SubassemblyFilter) {
  let url = `subassemblies?`;

  if (payload.month) {
    url += `month=${payload.month}&`;
  }

  if (payload.search) {
    url += `search=${payload.search}`;
  }

  if (payload.limit) {
    url += `&offset=${payload.offset}&limit=${payload.limit}`;
  }

  const response = await axiosInstance.get(url);
  return response.data;
}

export async function getSubassembly(payload: SubassemblyPayload) {
  let url = `subassemblies/${payload.id}?`;

  if (payload.month) {
    url += `month=${payload.month}&`;
  }
  const response = await axiosInstance.get(url);
  return response.data;
}

export async function saveSubassembly(subassembly: Subassembly) {
  await axiosInstance.post(`subassemblies`, subassembly);
}

